import { UserManager, WebStorageStateStore } from "oidc-client"
import store from "@/store"

const oidcConfig = {
  authority: process.env.VUE_APP_OIDC_AUTHORITY,
  client_id: "forest-web",
  scope: "openid profile offline_access groups permissions",
  automaticSilentRenew: true,
  redirect_uri: `${window.location.origin}/callback`, // Redirect URI for handling the OIDC callback
  post_logout_redirect_uri: `${window.location.origin}/internal/login`, // Where to go after logging out
  response_type: "code", // Authorization Code Flow
  userStore: new WebStorageStateStore({ store: window.localStorage }), // Store tokens in localStorage
  loadUserInfo: false, // Load user info after login
}

const userManager = new UserManager(oidcConfig)

export const oidcService = {
  async login() {
    return await userManager.signinRedirect()
  },

  async handleCallback() {
    return await userManager.signinRedirectCallback()
  },

  async logout() {
    return await userManager.signoutRedirect()
  },

  async getUser() {
    return await userManager.getUser()
  },

  async renewToken() {
    return await userManager.signinSilent()
  },
}

userManager.events.addUserLoaded((listener) => {
  store.commit("authStore/SET_USER", listener)
})
